import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ContractStatementEmail extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    fetchResult(req) {
        return this.repo.emailContractPDF(req);
    }
}
export default ContractStatementEmail;
